import apiClient from "../apiClient";
import { ENDPOINTS } from "../endpoints";

export const ticketService = {
  list: async (params = {}) => (await apiClient.get(ENDPOINTS.tickets, { params })).data,
  listBoard: async (params = {}) => (await apiClient.get(ENDPOINTS.ticketsBoard, { params })).data,
  get: async (id) => (await apiClient.get(ENDPOINTS.ticket(id))).data,
  create: async (payload) => (await apiClient.post(ENDPOINTS.tickets, payload)).data,
  update: async (id, payload) => (await apiClient.patch(ENDPOINTS.ticket(id), payload)).data,
  bulkUpdate: async (payload) => (await apiClient.post(ENDPOINTS.ticketBulkUpdate, payload)).data,

  history: async (id) => (await apiClient.get(ENDPOINTS.ticketHistory(id))).data,
  sla: async (id) => (await apiClient.get(ENDPOINTS.ticketSla(id))).data,

  listComments: async (id) => (await apiClient.get(ENDPOINTS.ticketComments(id))).data,
  addComment: async (id, payload) => (await apiClient.post(ENDPOINTS.ticketComments(id), payload)).data,

  listAttachments: async (id) => (await apiClient.get(ENDPOINTS.ticketAttachments(id))).data,
  addAttachment: async (id, payload) => (await apiClient.post(ENDPOINTS.ticketAttachments(id), payload)).data,
  uploadAttachment: async (id, file, commentId) => {
    const form = new FormData();
    form.append("file", file);
    if (commentId) form.append("comment_id", commentId);
    // Let axios/the browser set the multipart Content-Type (with boundary) itself --
    // the apiClient instance defaults to application/json, which would break this upload.
    return (await apiClient.post(ENDPOINTS.ticketAttachmentUpload(id), form, { headers: { "Content-Type": undefined } })).data;
  },
  downloadAttachment: async (id, attachmentId) =>
    (await apiClient.get(ENDPOINTS.ticketAttachmentDownload(id, attachmentId), { responseType: "blob" })).data,

  listWatchers: async (id) => (await apiClient.get(ENDPOINTS.ticketWatchers(id))).data,
  addWatcher: async (id, employeeId) =>
    (await apiClient.post(ENDPOINTS.ticketWatchers(id), { employee_id: employeeId })).data,
  removeWatcher: async (id, employeeId) =>
    (await apiClient.delete(ENDPOINTS.ticketWatcher(id, employeeId))).data,

  dashboardSummary: async () => (await apiClient.get(ENDPOINTS.dashboardSummary)).data,
};
